import { render, staticRenderFns } from "./view-rental-controls.vue?vue&type=template&id=65b5915a"
import script from "./view-rental-controls.vue?vue&type=script&lang=js"
export * from "./view-rental-controls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports